import { User } from "../../common/external-sources/Users";
import { EntryTypes } from "../../common/fields";
import { DataTypes } from "../../../data/DataManager";
import { InputTypes } from "../../../form/FormManager";
import { FieldSchema } from "../../../Schema";
import { LinkedInstance } from "../../common/external-sources/LinkedInstances";
import { Modes } from "../../common/fields/mode";

export const dateOfLastMaintanance: FieldSchema = {
  grid: {
    displayed: true,
    order: 32,
    ignoredForSearch: true,
  },
  name: "dateOfLastMaintanance",
  data: { type: DataTypes.DATE },
  display: {
    displayed: true,
  },
  // See dateOfLastCalibration: a getter, so "today" is the day the row is validated rather
  // than the day the module happened to be imported.
  validation: {
    maxDate: {
      getter: () => new Date(),
      fields: [],
      disabledCache: true,
    },
  },
  form: {
    label: "Date of executed maintenance",
    type: InputTypes.DATE,
    disabled: {
      getter: ({ entryType, linkedInstance, mode, currentUser }) => {
        return (
          [EntryTypes.STANDALONE_EQUIPMENT, EntryTypes.CLUSTER_SUBEQUIPMENT].includes(entryType as EntryTypes) &&
          [Modes.EDIT, Modes.BULK_EDIT].includes(mode as Modes) &&
          ["P1S Bi-Directional","P1S Uni-Directional"].includes((linkedInstance as LinkedInstance)?.linkedInstance)
        ) && !(currentUser as User)?.isAdmin;
      },
      fields: ["entryType", "linkedInstance", "mode", "currentUser"],
    },
  },
};
